query termsItems($scenarioId: ID!, $originId: ID!, $filter: TermFilterInput) {
  data(scenarioId: $scenarioId, originId: $originId) {
    terms(filter: $filter) {
      items {
        id
        code
        start_date
        end_date
        name
      }
      pageInfo {
        hasPreviousPage
        hasNextPage
        page
        size
        total
      }
    }
  }
}
